import cn from 'classnames';
import React, { type HTMLProps } from 'react';

import { Icon } from '../Icon';
import styles from './Checkbox.module.scss';

type Props = {
  checked?: boolean;
  children?: React.ReactNode;
  onChange?: (checked: boolean) => void;
  error?: boolean;
  classNames?: {
    root?: string;
    label?: string;
    checkbox?: string;
  };
} & Omit<HTMLProps<HTMLInputElement>, 'onChange'>;

export const Checkbox = ({
  checked,
  onChange,
  children,
  disabled,
  error,
  classNames,
}: Props) => (
  <div
    className={cn(styles.wrapper, classNames?.root, {
      [styles.checked]: checked,
      [styles.disabled]: disabled,
      [styles.error]: error,
    })}
    role="checkbox"
    tabIndex={0}
    aria-checked={checked}
    onClick={() => !disabled && onChange?.(!checked)}
  >
    <div className={cn(styles.checkbox, classNames?.checkbox)}>
      {checked && <Icon name="outlinedCheck" />}
    </div>
    {children && <div className={classNames?.label}>{children}</div>}
  </div>
);
